// ============================================================
// Student Fee Installments API
// ============================================================
// Provides endpoints to fetch fee summary and installment schedule
// for a specific student, scoped by schoolId.

import client from './axios';

export const studentFeeInstallmentsApi = {
  /**
   * Get overall fee summary for a student (total_fee, paid, balance)
   * @param {string} studentId - Student UUID
   * @param {string} schoolId - School UUID
   */
  getFeeSummary: async (studentId, schoolId) => {
    if (!studentId || !schoolId) return { total_fee: 0, paid: 0, balance: 0 };
    const response = await client.get(
      `/student-fee-installment/${studentId}/fee-summary?school_id=${schoolId}`
    );
    return response.data;
  },

  /**
   * Get list of fee installments for a student
   * @param {string} studentId - Student UUID
   * @param {string} schoolId - School UUID
   */
  getStudentInstallments: async (studentId, schoolId) => {
    if (!studentId || !schoolId) return [];
    const response = await client.get(
      `/student-fee-installment/${studentId}/fee-installments?school_id=${schoolId}`
    );
    const data = response.data;
    return Array.isArray(data) ? data : data?.data || data?.items || [];
  },
};
